import { useMutation } from '@tanstack/react-query'
import { useRef } from 'react'
import { useAuth } from '../providers'
import { v1Client } from '../api'
import { postTopUpPurchase } from './top-up-purchase'

/**
 * Buys meeting hours via POST /billing/meeting-minutes/top-ups, charged to the
 * card on file. Orb grants and meters the allowance in minutes, so this is the
 * one place that takes minutes rather than the hours everything above it
 * counts. Key lifecycle and error shaping live in postTopUpPurchase.
 */
export const useAddMeetingMinutes = () => {
  const { getAuthToken } = useAuth()
  const pendingKeys = useRef(new Map<string, string>())

  return useMutation({
    mutationFn: async (minutes: number) => {
      const token = await getAuthToken()
      return postTopUpPurchase(pendingKeys, {
        request: String(minutes),
        fallbackMessage: 'Failed to add hours. Please try again.',
        paymentMethodMessage: 'Failed to add hours. Please ensure you have a valid payment method.',
        post: (idempotencyKey) =>
          v1Client.POST('/billing/meeting-minutes/top-ups', {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: { minutes, idempotencyKey },
          }),
      })
    },
    onError: (error) => {
      console.error('Add meeting minutes error:', error)
    },
  })
}
